import { render, staticRenderFns } from "./CompraVenta.vue?vue&type=template&id=c1042b62"
import script from "./CompraVenta.vue?vue&type=script&lang=js"
export * from "./CompraVenta.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CompraVenta.vue?vue&type=style&index=1&id=c1042b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports